var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.properClass,on:{"click":_vm.clickHandler}},[_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hamburger-box"},[_c('div',{staticClass:"hamburger-inner"})])}]

export { render, staticRenderFns }